import React from "react";

const faqData = [
  {
    question: "What is this application about?",
    answer:
      "This application allows you to view lyrics for songs playing on Spotify as well as have some additional shortcuts for adding songs to your library."
  },
  {
    question: "What's the popularity score ?",
    answer:
      "The popularity index is provided from spotify and varies from 1 to 99 depending on how popular the song is."
  },
  {
    question: "Why some lyrics are not synchronized with the song?",
    answer:
      "SpotifyPanel rely on open source libraries to get the lyrics. Sometimes the lyrics are not synchronized with the song. This is especially true for live songs."
  },
  {
    question: "Does spotify Panel store any data?",
    answer:
      "We only store your spotify user_id for payment purpose. We do not store any additional credit card or spotify usage data."
  },
  {
    question: "Why sometimes the track menus won't working?",
    answer:
      "Spotify API has some limitations especially if multiple devices are being used at the same account. This is a known issue. In that case try stopping other devices from playing Spotify."
  }
];

const HelpView: React.FunctionComponent = () => {
  return (
    <div>
      <h1>Frequently Asked Questions</h1>
      <ul>
        {faqData.map((faq, index) => (
          <li key={index}>
            <h2>{faq.question}</h2>
            <p>{faq.answer}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default HelpView;
